import React, {Component} from 'react';
// import Header from '../decoration/header';
import HeaderMainpage from '../decoration/headerMainpage';
import MainCaption from "./mainCaption";
import ShopnowIcon from "./shopnowIcon";
// import './windows.css';

const mainWindowStyle = {
  height: "700px",
  display: "flex",
  justifyContent:"center",
  alignItems:"center",
  flexDirection: "column",
  backgroundColor:"#000",
  opacity:0.8
}

class Windows extends Component {
    render() {
      return (
        <div className="Windows">
          <div className="windowsContainer">
            <HeaderMainpage/>
            <div style={mainWindowStyle}>
              <MainCaption />
              <ShopnowIcon />
            </div>
          </div>
        </div>
      );
    }
}

export default Windows;



// WEBPACK FOOTER //
// ./src/components/homepage/windows.js